<template>
  <v-container id="campuses" fluid tag="section">
    <v-row justify="center">
      <v-col cols="12" md="12">
        <base-material-card
          :title="$i18n.t('Manage your Security Settings')"
          icon="mdi-key"
          class="px-3 py-3 small-icon"
          color="primary"
        >
          <v-form id="form" ref="form" v-model="valid">
            <v-container>
              <v-col cols="12" md="10">
                <v-text-field
                  :label="$i18n.t('Old Password') + '*'"
                  required
                  v-model="pass.current_password"
                  type="password"
                ></v-text-field>
              </v-col>
              <v-col cols="12" md="10">
                <v-text-field
                  :label="$i18n.t('New Password') + '*'"
                  required
                  v-model="pass.password"
                  :rules="validationrules.newPassword"
                  type="password"
                ></v-text-field>
              </v-col>
              <v-col cols="12" md="10">
                <v-text-field
                  :label="$i18n.t('Confirm Password') + '*'"
                  required
                  v-model="newPassword"
                  :rules="validationrules.newPassword"
                  type="password"
                ></v-text-field>
              </v-col>
              <v-list>
                <v-list-item-group>
                  <v-list-item v-for="(item, i) in items" :key="i">
                    <v-list-item-icon>
                      <v-icon v-text="item.icon"></v-icon>
                    </v-list-item-icon>
                    <v-list-item-content>
                      <v-list-item-title v-text="item.text"></v-list-item-title>
                    </v-list-item-content>
                  </v-list-item>
                </v-list-item-group>
              </v-list>
            </v-container>
            <v-col cols="12" class="text-right">
              <v-btn
                color="success"
                class="mr-0"
                @click="save()"
                :loading="loading"
                :disabled="!valid"
              >
                <h3>{{ $i18n.t("Save") }}</h3>
              </v-btn>
            </v-col>
          </v-form>
        </base-material-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import { Vue, Component } from "vue-property-decorator";
import { doPost } from "@/store/common/module/apis";
import common from "@/store/common/module/common";

@Component
export default class Holidays extends Vue {
  url = "/api/corp/config/get";
  pass = {
    password: "",
    confirmPassword: "",
  };
  newPassword = "";
  value = "";
  valid = true;
  items = [
    {
      icon: "mdi-disc",
      text: this.$i18n.t("Atleast 9 characters"),
    },
    {
      icon: "mdi-disc",
      text: this.$i18n.t("Atleast 1 Digit"),
    },
    {
      icon: "mdi-disc",
      text: this.$i18n.t("Atleast 1 Lowercase letter"),
    },
    {
      icon: "mdi-disc",
      text: this.$i18n.t("Atleast 1 Uppercase letter"),
    },
    {
      icon: "mdi-disc",
      text: this.$i18n.t("Atleast 1 Special characters"),
    },
  ];
  validationrules = {
    password: [(v) => !!v || this.$i18n.t("Password is required")],
    newPassword: [(v) => !!v || this.$i18n.t("New Password is required")],
  };

  get loading() {
    return common.loading;
  }

  async save() {
    try {
      if (this.pass.password !== this.newPassword) {
        common.setError("The password you have entered not matched!");
        return;
      }
      common.setLoading(true);
      await doPost("/api/member/changePassword", this.pass);
      common.setLoading(false);
      common.showMessage("Saved Successfully");
    } catch (e) {
      common.setError(e);
      common.setLoading(false);
    }
  }
}
</script>

<style scoped>
.pac-target-input {
  width: 50%;
  border: 1px solid #dfdfdf;
  height: 30px;
  padding: 10px 20px;
  z-index: 1;
  background: white;
  margin-left: 25%;
  position: absolute;
  margin-top: 10px;
}
#bookingCheckbox {
  margin-left: 20px;
  margin-right: 20px;
  justify-content: space-between;
}
</style>
